import React, { useRef } from 'react';
import { TooltipContainer, useTooltip } from '@workday/canvas-kit-react/tooltip';
import { Popper, Placement } from '@workday/canvas-kit-react/popup';
import MiddleEllipsis from 'react-middle-ellipsis';
import classNames from 'classnames';
import './MiddleEllipsisWithTooltip.scss';

interface MiddleEllipsisWithTooltipProps {
    className?: string;
    tooltipPlacement?: Placement;
    text: string;
    tooltipEnabled?: boolean;
}

export function MiddleEllipsisWithTooltip({
    className = '',
    text,
    tooltipEnabled = true,
    tooltipPlacement = 'bottom-start'
}: MiddleEllipsisWithTooltipProps) {
    const { targetProps, popperProps, tooltipProps } = useTooltip<HTMLDivElement>();
    const textRef = useRef<HTMLDivElement | null>(null);

    return (
        <>
            <div
                ref={textRef}
                className={classNames('middleEllipsisWithTooltip', {
                    [className]: !!className
                })}
                {...targetProps}>
                <MiddleEllipsis>
                    <span>{text}</span>
                </MiddleEllipsis>
            </div>
            {tooltipEnabled && textRef.current?.innerText !== text && (
                <Popper
                    placement={tooltipPlacement}
                    ref={popperProps.ref}
                    anchorElement={popperProps.anchorElement}
                    open={popperProps.open}>
                    <TooltipContainer {...tooltipProps}>{text}</TooltipContainer>
                </Popper>
            )}
        </>
    );
}
